import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'eco_friendly-definition_banner_show_more_button-click';
/**
 * User clicks the &quot;Show more&quot; button at Eco-friendly definition banner at Eco-friendly c1&#x2F;c2 page.
 */
export function trackEcoFriendlyDefinitionBannerShowMoreButtonClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
